import { useEffect, useRef } from "react";
import { useSocket } from "./useSocket";

export function useSocketListener<T>(
  event: string,
  handler: (data: T) => void
) {
  const { socket } = useSocket();
  const handlerRef = useRef(handler);

  // Güncel handler'ı ref'e yaz
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!socket) return;

    const internalHandler = (data: T) => {
      handlerRef.current(data);
    };

    socket.on(event, internalHandler);
    return () => {
      socket.off(event, internalHandler);
    };
  }, [socket, event]);
}
